/**
 * Only returns true if user is member of a team with an active enterprise subscription. Use this to display enterprise specific features.
 */

import useAuthSettings from '@apps/www/src/www/hooks/useAuthSettings';
import UserClass from '@pkgs/shared/enums/UserClass';
import userClassHasUserClassPrivileges from '@pkgs/shared/helpers/userClassHasUserClassPrivileges';

export default function useAuthHasUserClass(userClass: ValueOf<typeof UserClass>) {
	const authSettings = useAuthSettings(['class']);

	return userClassHasUserClassPrivileges(authSettings?.class, userClass);
}
